import { ListingType } from 'algolia-api/types/ListingType';
import { StaffTypeFilter } from 'algolia-api/types/StaffTypeFilter';
import { LISTING_TYPE_HUMAN_NAME_MAP_SEARCH } from 'utils/constants/general/listingTypeHumanNameMapSearch';

import { ListingTypeSelectStyled } from './ListingTypeSelect.styled';

type DisplayedType = ListingType | StaffTypeFilter;

type Props = {
  value: string;
  onChange: (option: ListingType) => void;
  listingTypes: Array<DisplayedType>;
  variant: 'grey' | 'outline-blue';
};

export function ListingTypeSelect({
  value,
  onChange,
  listingTypes,
  variant,
  ...props
}: Props) {
  const options = listingTypes.map((type) => ({
    value: type,
    label: LISTING_TYPE_HUMAN_NAME_MAP_SEARCH[type],
  }));

  return (
    <ListingTypeSelectStyled
      data-qa-id="listing-type-select"
      aria-label={getText('Select listing type')}
      name="listing-type"
      options={options}
      onChange={(newValue) => onChange(newValue?.value as ListingType)}
      value={value}
      isClearable={false}
      disabled={listingTypes.length === 1}
      height={48}
      $variant={variant}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
